// Utility functions for normalizing case of keys/labels

// Convert a string like "Course Name", "course_name", "COURSE-NAME" to "courseName"
export function toCamelCase(input: string): string {
  if (!input) return "";
  const normalized = input
    .replace(/\./g, " ")
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/[^a-zA-Z0-9]+/g, " ")
    .trim()
    .toLowerCase();
  if (!normalized) return "";
  const parts = normalized.split(" ").filter(Boolean);
  return parts
    .map((part, index) =>
      index === 0 ? part : part.charAt(0).toUpperCase() + part.slice(1)
    )
    .join("");
}

// Shallow-convert the first-level keys of a row object to camelCase
export function transformKeysToCamelCase<T extends Record<string, any>>(
  row: T
): Record<string, any> {
  const result: Record<string, any> = {};
  for (const [key, value] of Object.entries(row || {})) {
    const camelKey = toCamelCase(String(key));
    if (!camelKey) continue;
    result[camelKey] = value;
  }
  return result;
}

// Alias: normalizeRowKeys is the same as transformKeysToCamelCase
export function normalizeRowKeys<T extends Record<string, any>>(
  row: T
): Record<string, any> {
  return transformKeysToCamelCase(row);
}
